// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColorPicker_wrapper__3DMe7","notification":"ColorPicker_notification__-KO2w"};